const getAuditlogsActions = {
    GET_AUDITLOGS: 'GET_AUDITLOGS',
    SET_AUDITLOGS: 'SET_AUDITLOGS'
};

export default getAuditlogsActions;